import {FC, useEffect, useState} from "react";
import {APP} from "../../Utils/Constants.ts";


interface ScheduleProps {
  handleSchedule: (filterId:string, value:any) => void;
  value: Filter|undefined;
}
const Schedule: FC<ScheduleProps> = ({handleSchedule, value}) => {

    const defaultValues = () => {
      return value ? value.values : [];
    }

    const [scheduleValue, setScheduleValue] = useState<string[]>(defaultValues())

    const idEvening = "evening";
    const idDay = "day";
    const idWeekend = "weekend";

    const isChecked = (id:string) => {
        if(value && Array.isArray(value.values)) {
            return value.values.includes(id);
        }
        return false
    }

    const handleChange = (e: any) => {
      const { checked, value } = e.target;

      setScheduleValue(prev => {
        // If checked, add the value to the array
        if (checked) {
            return [...prev, value];
        } else {
          // If unchecked, remove the value from the array
          return prev.filter(item => item !== value);
        }
      });
    };

  useEffect(() => {
    if(value == undefined || value.values.length == 0 ){
      setScheduleValue([]);
    }
  }, [value]);

    useEffect(() => {
      handleSchedule(APP.FILTER.SCHEDULE.FIELD, scheduleValue)
    }, [scheduleValue]);

    return(
        <>
            <div className={'filter-wrapper schedule__wrapper'}>
              <span className="filter-label">{Drupal.t("Horaire")}</span>
                <div key={idDay} className={'checkbox-input'}>
                    <input
                        checked={isChecked(idDay)}
                        onChange={handleChange}
                        id={idDay}
                        name={idDay}
                        type={'checkbox'}
                        value={idDay}
                    />
                    <label htmlFor={idDay}>{Drupal.t("Journée")}</label>
                </div>
              <div key={idEvening} className={'checkbox-input'}>
                <input
                  checked={isChecked(idEvening)}
                  onChange={handleChange}
                  id={idEvening}
                  name={idEvening}
                  type={'checkbox'}
                  value={idEvening}
                />
                <label htmlFor={idEvening}>{Drupal.t("Soirée")}</label>
              </div>
              <div key={idWeekend} className={'checkbox-input'}>
                <input
                  checked={isChecked(idWeekend)}
                  onChange={handleChange}
                  id={idWeekend}
                  name={idWeekend}
                  type={'checkbox'}
                  value={idWeekend}
                />
                <label htmlFor={idWeekend}>{Drupal.t("Samedi")}</label>
              </div>
            </div>
        </>
    )
}

export default Schedule;
